const ProjectList = [
    {
        "title": " Adaptive Automation of Workflow (Final Year PRoject)",
        "stack": "Next.js , TypeScript ",
        "desc": "This project introduces an innovative workflow management platform designed to streamline the task management process through automated task suggestions. Built using modern web technologies, the application leverages advanced AI to identify and recommend missing tasks and subtasks, thereby enhancing user productivity and task accuracy. ",
        "github": "https://github.com/RushikeshPadaval/Adaptive-Automation-of-Workflow",
        "website": "https://taskido-pearl.vercel.app/"

    },
    {
        "title": "JobPortal",
        "stack": "MERN",
        "desc": "Developed a full-stack job portal that allows companies to post job openings and applicants to view listings and apply. The platform includes user authentication for secure access, job categorization for easier navigation, and real-time application tracking for both employers and candidates. It also integrates Google Forms for application submission and tracks user activity for each job post to provide insights into engagement and application flow.",
        "github" : "https://github.com/RushikeshPadaval/Job_Portal",
    },
    {
        "title": "Book Store",
        "stack": "MERN",
        "desc": " Built a full-stack online bookstore with user authentication features including login/logout, and product listing with book details and pricing Implemented a clean UI for browsing books and managing user sessions in a simple, responsive layou",
    
    },

];

export default ProjectList;
